import React from 'react'
import Helmet from 'react-helmet'
import 'normalize.css'

import './index.scss'

import Footer from './Footer'
import SEO from '../components/SEO'

export default class MainLayout extends React.Component {
  render() {
    const { children } = this.props
    return (
      <div className="wrapper">
        <Helmet>
          <title>NOLTE Architektur</title>
        </Helmet>
        <SEO />

        {/* <Navbar /> */}
        <section className="content">{children}</section>
        <Footer />
      </div>
    )
  }
}
